enum PensionAccountType {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE',
  OTHER = 'OTHER',
}

export default PensionAccountType;
